import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageSquare } from 'lucide-react';
export function FloatingActions() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-173" data-mp="9ewyy0b8jrum">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 40,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 40,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 22
    }} className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-[1000] flex flex-col gap-3 items-end" data-id="element-174" data-mp="9dltzx620e1x">
          {/* Text/SMS Button */}
          <motion.a href="sms:8312407401" aria-label="Text Jose's Junk Removal" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="flex items-center justify-center w-14 h-14 bg-white text-[#1A1A1A] rounded-full shadow-[0_8px_24px_rgba(0,0,0,0.25)] border border-gray-200 hover:bg-gray-100 transition-colors" data-id="element-175" data-mp="bakjbg2hf2x5">
            <MessageSquare size={22} data-id="element-176" data-mp="q08j2cv0ltir" />
          </motion.a>

          {/* Call Button - primary, with pulse */}
          <motion.a href="tel:8312407401" aria-label="Call Jose's Junk Removal" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="relative flex items-center justify-center w-16 h-16 bg-[#C8102E] text-white rounded-full shadow-[0_10px_30px_rgba(200,16,46,0.45)] hover:bg-red-800 transition-colors" data-id="element-177" data-mp="l1ffbc5j5gvs">
            {/* Pulse ring */}
            <span className="absolute inset-0 rounded-full bg-[#C8102E] animate-ping opacity-30 pointer-events-none" data-id="element-178" data-mp="3c5afng6r23ys"></span>
            <Phone size={26} className="relative text-white" data-id="element-179" data-mp="32974jktx6uzp" />
          </motion.a>
        </motion.div>}
    </AnimatePresence>;
}